export abstract class MtHelper {

  static isValidToken(tokenExpirationTime: number, shift: number): boolean {
    return MtHelper.getDiffInSeconds(new Date(tokenExpirationTime), new Date()) >= shift;
  }

  static isUserActive(userLastActivityTime: number, shift: number): boolean {
    return MtHelper.getDiffInSeconds(new Date(userLastActivityTime), new Date()) <= shift;
  }

  static getAlertTime(refreshTokenExpirationTime: number, shift: number): number {
    const tokenExpirationTime = new Date(0).setUTCSeconds(refreshTokenExpirationTime).valueOf();
    const dateNow = new Date().valueOf();
    return tokenExpirationTime - dateNow - (shift * 1000);
  }

  private static getDiffInSeconds(date1: Date, date2: Date): number {
    const diff = ((date2.getTime() - date1.getTime()) / 1000);
    return Math.abs(Math.round(diff));
  }

}
